import './ViewModeToggle.scss';
import React from 'react';
import clsx from 'clsx';
import { MdTableRows, MdViewColumn } from 'react-icons/md';
import Tooltip from '@srm/ui/tooltip';
import { WinnerTableView } from '../hooks/useTableViewMode';

interface IProps {
    value: WinnerTableView;
    onChange: (v: WinnerTableView) => void;
}

/**
 * Компактный segmented-переключатель ориентации таблицы, живёт в левом-верхнем
 * углу матрицы (sticky-th). Две иконо-кнопки с tooltip:
 * - byCriteria — строки = критерии, столбцы = предложения (исходный вид);
 * - byOffer    — строки = предложения, столбцы = критерии (транспонированный).
 */
export const ViewModeToggle: React.FC<IProps> = ({ value, onChange }) => (
    <div className="ws-view-toggle" role="group" aria-label="Представление таблицы">
        <Tooltip openDelay={200} background="black" position="bottom" label="Строки — критерии, столбцы — предложения">
            <button
                type="button"
                className={clsx('ws-view-toggle__btn', { 'is-active': value === 'byCriteria' })}
                aria-pressed={value === 'byCriteria'}
                aria-label="Строки — критерии"
                onClick={() => onChange('byCriteria')}
            >
                <MdTableRows size="15px" />
            </button>
        </Tooltip>
        <Tooltip openDelay={200} background="black" position="bottom" label="Строки — предложения, столбцы — критерии">
            <button
                type="button"
                className={clsx('ws-view-toggle__btn', { 'is-active': value === 'byOffer' })}
                aria-pressed={value === 'byOffer'}
                aria-label="Строки — предложения"
                onClick={() => onChange('byOffer')}
            >
                <MdViewColumn size="15px" />
            </button>
        </Tooltip>
    </div>
);
